// extracted by mini-css-extract-plugin
export default {"OneNewFilter":"OneNewFilter_OneNewFilter__+W2iH"};